// ReportBreakdown.styles.ts
import { Theme } from '@mui/material/styles';
import { makeStyles } from '@mui/styles';
import { Colors, FontWeight } from '../../../../assets/styles';

const amount = {
  width: '25%',
  color: Colors.Gray4,
  fontSize: 14,
  textAlign: 'center' as const,
};

const title = {
  color: Colors.Blue,
  fontSize: 12,
  fontWeight: FontWeight.Regular,
};

export const useReportBreakdownStyles = makeStyles((theme: Theme) => ({
  tableContainer: {
    height: '100%',
    width: '100%',
    paddingLeft:'35px',
    paddingBottom:'20px',
    pageBreakBefore: 'always'
  },
  table: {
    marginTop: 20,
    fontSize: '12px',
    height: '100%',
    width: '100%',
    display: 'table',
    border: `1px solid ${Colors.Gray1}`,
    marginBottom:'20px'
  },
  columnTitle: {
    color: Colors.Gray,
    fontWeight: FontWeight.Light,
    fontSize: 14,
    textAlign: 'center',
  },
  sectionTitle: {
    ...title,
    color:'black',
    fontSize: '16px',
    padding:'12px',
    fontWeight: 700,
  },
  contentTitle: {
    marginBottom: 24,
  },
  subsectionTitle: {
    ...title,
    color:'black',
    fontWeight: 300,
    fontSize: 16,
    borderRight: `1px solid
    rgba(224, 224, 224, 1)`,
    padding:'12px',
    margin:'0px',
  },
  sectionAmount: {
    ...amount,
  },
  subsectionAmount: {
    ...amount,
    backgroundColor: 'rgba(204,204,204,0.1)',
  },
  descriptionCol: {
    width: '30%',
    padding: '1px',
    color: '#008DCD',
    fontSize: '1.125rem',
    fontFamily: 'Museo Sans,sans-serif',
    fontWeight: 700,
    lineHeight: 1.2,
  },
  descriptionText: {
    margin: 0,
    fontSize: '14px',
    color: 'black !important',
    padding: '7px 0px 7px 0px',
    borderBottom: 'none !important'
  },
  noteText: {
    margin: '4px 8px',
    padding: '2px 4px',
    borderLeft: '1px solid #999898',
    marginLeft: '8px',
    borderTop: '1px solid #9998982e',
  },
  valuesCol: {
    padding: '0px',
    '& div:last-of-type': {
      border: 'none',
    },
  },
  valueCell: {
    display: 'flex',
    textAlign: 'center',
    border: 'none',
    borderRight: 'none',
    height: '100%',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 0,
    color:'black',
    fontWeight: 300,
    fontSize: 16,
  },
  full: {
    width: '70%',
    height: '100%',
  },
  half: {
    width: '20%',
    height: '100%',
  },
  third: {
    width: '13%',
    height: '100%',
  },
  smallText: {
    fontSize: 10,
    fontWeight: FontWeight.Light,
  },
  composedCell: {
    padding: 0,
    margin: 0,
    height: '100%',
  },
  multiCont: {
    display: 'flex',
    height: '100%',
    '& div:last-of-type': {
      borderBottom: 'none',
    },
  },
}));
export const useTableCellStyles = makeStyles((theme: Theme) => ({
  root: {
    border: `1px solid ${Colors.Gray5}`,
  },
}));
